import get from '../../../common/services/api/get';

export default function getPodNames() {
    return get('/api/v1/instances/vault_pods');
}
